import React from 'react';
import { Link } from 'react-router-dom';
import { Splide, SplideSlide } from '@splidejs/react-splide';

import '@splidejs/react-splide/css';

// Media //
import prodotti from '../media/Prodotti.png';
import r_d from '../media/Applications2.jpeg';
import servizi from '../media/Servizi.png';

function Solution() {
  const slideImages = [prodotti, servizi, r_d];
  return (
    <section className="bg-gray-800 md:pb-8">
      <h3 className="py-8 text-4xl font-bold text-center text-white">
        What we do...
      </h3>
      {/* INIZIO --- Mobile */}

      <div className="block w-full h-full mx-auto bg-black md:hidden">
        <Splide aria-label="My Slider">
          <SplideSlide>
            <Link to="/products">
              <img
                src={slideImages[0]}
                alt="1"
                className="object-fill h-full"
              />
              <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full text-4xl font-bold text-white bg-black/75">
                Products
              </div>
            </Link>
          </SplideSlide>
          <SplideSlide>
            <Link to="/services">
              <img
                src={slideImages[1]}
                alt="2"
                className="object-fill h-full"
              />
              <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full text-4xl font-bold text-white bg-black/75">
                Services
              </div>
            </Link>
          </SplideSlide>
          <SplideSlide className="">
            <Link to="/projects">
              <img
                src={slideImages[2]}
                alt="3"
                className="object-fill h-full"
              />
              <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full text-4xl font-bold text-white bg-black/75">
                Projects
              </div>
            </Link>
          </SplideSlide>
        </Splide>
      </div>

      {/* FINE --- Mobile */}

      {/* INIZIO -- Desktop */}

      <div className="hidden md:flex items-center justify-between w-full mx-auto container h-[700px]">
        <div className="relative w-full h-full duration-300 ease-in-out bg-red-50 basis-1/3 hover:basis-2/3 group">
          <img
            src={slideImages[0]}
            alt="electric-car"
            className="object-cover w-full h-full "
          />
          <Link to="/products">
            <div className="absolute w-full h-[700px] top-0 flex flex-col justify-end items-center group-hover:flex group-hover:flex-col group-hover:bg-black/70 group-hover:transition-all group-hover:duration-150">
              <h1 className="w-full py-8 mb-12 text-4xl font-bold text-center text-white bg-black/70 group-hover:bg-transparent group-hover:transition-all group-hover:duration-50">
                Products
              </h1>
            </div>
          </Link>
        </div>
        <div className="relative w-full h-full duration-300 ease-in-out bg-red-50 basis-1/3 hover:basis-2/3 group">
          <img
            src={slideImages[1]}
            alt="boat"
            className="object-cover w-full h-full"
          />
          <Link to="/services">
            <div className="absolute w-full h-[700px] top-0 flex flex-col justify-end items-center group-hover:flex group-hover:flex-col group-hover:bg-black/70 group-hover:transition-all group-hover:duration-150">
              <h1 className="w-full py-8 mb-12 text-4xl font-bold text-center text-white bg-black/70 group-hover:bg-transparent group-hover:transition-all group-hover:duration-50">
                Services
              </h1>
            </div>
          </Link>
        </div>
        <div className="relative w-full h-full duration-300 ease-in-out bg-red-50 basis-1/3 hover:basis-2/3 group">
          <img
            src={slideImages[2]}
            alt="battery"
            className="object-cover w-full h-full"
          />
          <Link to="/projects">
            <div className="absolute w-full h-[700px] top-0 flex flex-col justify-end items-center group-hover:flex group-hover:flex-col group-hover:bg-black/70 group-hover:transition-all group-hover:duration-150">
              <h1 className="w-full py-8 mb-12 text-4xl font-bold text-center text-white bg-black/70 group-hover:bg-transparent group-hover:transition-all group-hover:duration-50">
                Projects
              </h1>
            </div>
          </Link>
        </div>
      </div>

      {/* FINE -- Desktop */}
    </section>
  );
}

export default Solution;
